module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-background-primary uk-container uk-container-large uk-background-primary tm-navbar-container"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, _vm._l((_vm.ShopItemRelatedTypes), function(ShopItemRelatedType) {
    return (_vm.RelatedShopItems[ShopItemRelatedType.id]) ? _c('li', {
      key: ShopItemRelatedType.id
    }, [_c('a', {
      staticClass: "h-min-auto",
      attrs: {
        "href": ("#related-type-" + (ShopItemRelatedType.id))
      }
    }, [_vm._v(_vm._s(ShopItemRelatedType.name))])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a239b1aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopItem/RelatedMenu.vue
// module id = 94
// module chunks = 0